import CanEdit from './component';

export default CanEdit;
